import { Injectable } from '@angular/core';
import { ISessionService } from '@insight/services';

@Injectable({
	providedIn: 'root'
})
export class LogoutService {

	constructor(
		private sessionService: ISessionService,
	) { }

	logout() {
		this.sessionService.logout();
	}
}
